export const Constants = {
    DADA_ENDPOINT: 'https://api.dev.awstrp.net/dada/graphql',
    DADA_APIKEY: 'kRe9ayoN110IEvOM3lmHnJEosYan3zxVrNlKLebcNiEJvnew',
};
//# sourceMappingURL=api.constants.js.map